/**
 * Shared list of top niches for dropdowns and filters.
 * Used by EditIdentityModal (creator profile) and BrandDashboard (niche filter).
 */
export const TOP_NICHES = [
  'Lifestyle',
  'Beauty',
  'Fashion',
  'Fitness',
  'Travel',
  'Food & Drink',
  'Tech & Gadgets',
  'Gaming',
  'Business & Entrepreneurship',
  'Personal Finance',
  'Education & Study',
  'Health & Wellness',
  'Parenting & Family',
  'Art & Design',
  'Music & Entertainment',
];
